module.exports = __webpack_public_path__ + "static/title-graphic-f630925dfa9a9f016b761d03d478e2c4.png";